"use client"

import { useMutation } from "@tanstack/react-query"
import {
  refreshWhatsappNumberAction,
  type WhatsappNumberRefresh,
} from "@/server-actions/whatsapp-connect"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


/**
 * Re-reads the number's status from Meta and applies an approved display name by
 * re-registering the number (the fix for sends failing with 131037).
 */
export function useRefreshWhatsappNumberMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsWhatsappRefresh")

  return useMutation({
    mutationFn: async (channelId: string): Promise<WhatsappNumberRefresh> => {
      const result = await withQueryHandling(refreshWhatsappNumberAction({ channelId }), {
        loading: tUi("refreshingTheNumber"),
        success: (value) =>
          "reregistered" in value && value.reregistered
            ? "Number re-registered — the approved display name is now applied"
            : "Number status refreshed",
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
